module.exports = __webpack_public_path__ + "img/ksi.3cc710da.jpg";